export default __webpack_public_path__ + "static/media/icon_selling_white.a99b94ef.svg";